import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { MealBranchEntity } from '../../domain/entities/MealBranchEntity'
import type { MealBranchAdminDto } from '@/backend/market'

export class MealBranchModel extends MealBranchEntity {
  constructor(dataDto: MealBranchAdminDto) {
    super()
    mapEntityProperties<MealBranchEntity>(this, dataDto, {
      map: {
        branch: {
          ...dataDto.branch,
          brandImage: dataDto.branch?.brandProfileImageUrl
        }
      }
    })
  }
}
